import React, {Component, Fragment} from "react";
import Header from "./Header";
import VotesByHour from "./VotesByHour";
import TurnoutTable from "./TurnoutTable";
import ResultsTable from "./ResultsTable";
import axios from "axios";
import Footer from "./Footer";

class Home extends Component {

  constructor(props) {
    super(props);
    this.state = {
      snapshot: null,
      election: null,
      loading: false,
        votes:null
    };
  }

  componentDidMount() {
      this.loadElection('rwKdGC4n');
      this.loadVotesByHour('rwKdGC4n');
  }

    loadVotesByHour = election_id => {
        this.setState({ loading: true }, () =>
            axios({
                method: "get",
                url:
                    process.env.REACT_APP_BACKUP_URL +
                    "/" +
                    election_id +
                    "/votesByHour.json"
            })
                .then(response => {
                    this.setState({
                        loading: false,
                        votes: Object.entries(response.data.hourly).map(function(v) {
                            return { x: 1000 * parseInt(v[0]), y: v[1].electronic_voted };
                        })
                    });
                })
                .catch(error => {
                    if (error.response && error.response.status === 404) {
                        axios({
                            method: "get",
                            url:
                                process.env.REACT_APP_API_URL +
                                "/election/" +
                                election_id +
                                "/votesByHour"
                        })
                            .then(response => {
                                this.setState({
                                    loading: false,
                                    votes: Object.entries(response.data.hourly).map(function(v) {
                                        return {
                                            x: 1000 * parseInt(v[0]),
                                            y: v[1].electronic_voted
                                        };
                                    })
                                });
                            })
                            .catch(error => {
                                this.setState({ loading: false });
                            });
                    } else {
                        this.setState({ loading: false });
                    }
                })
        );
    };

    loadElection = election_id => {
    this.setState({ loading: true }, () =>
        axios({
          method: "get",
          url: process.env.REACT_APP_BACKUP_URL +
              "/" +
              election_id +
              "/header.json"
        })
            .then(response => {
              this.setState({ election: response.data, loading: false });
            })
            .catch(error => {
              if (error.response && error.response.status === 404) {
                axios({
                  method: "get",
                  url: process.env.REACT_APP_API_URL + "/election/" + election_id

                })
                    .then(response => {
                      this.setState({ election: response.data, loading: false });
                    })
                    .catch(error => {
                      this.setState({ loading: false });
                    });

              } else {
                this.setState({ loading: false });
              }
            })
    );
  };


  loadSnapshot = election_id => {

    this.setState({ loading: true }, () =>
      axios({
        method: "get",
        url:
          process.env.REACT_APP_BACKUP_URL +
          "/" +
          this.props.election_id +
          "/snapshot.json"
      })
        .then(response => {
          this.setState({
            loading: false,
            snapshot: response.data
          });
        })
        .catch(error => {
          if (error.response && error.response.status === 404) {
            axios({
              method: "get",
              url:
                process.env.REACT_APP_API_URL +
                "/election/" +
                election_id +
                "/snapshot"
            })
              .then(response => {
                this.setState({
                  loading: false,
                  snapshot: response.data
                });
              })
              .catch(error => {
                this.setState({ loading: false });
              });
          } else {
            this.setState({ loading: false });
          }
        })
    );
  };

  render() {
    return (
      <div className="container-fluid">

        {this.state.election != null  && this.state.votes != null && (
            <Fragment>
          <div className="row justify-content-center ">
            <div className="col-12">


              <Header election={this.state.election} />
            </div>
          </div>
<br/>
            <div className="row justify-content-center">
            <div className="col-12 col-sm-11 col-md-9 col-lg-7 text-right">
                <h4>Total votos recibidos: {(this.state.votes.map(v => v.y).reduce((a,b) => a + b, 0)).toLocaleString(
                    navigator.language,
                {maximumFractionDigits: 0}
                    )}</h4>
            </div>

            </div>
                <br/>
              <ResultsTable   election_id="rwKdGC4n" />

            </Fragment>
          )}

          <br/><br/>
          {this.state.votes != null && (
          <VotesByHour  votes={this.state.votes}/>
          )}

          <br/><br/>
        <Footer />
      </div>
    );
  }
}


export default Home;